// @mui
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import { m } from 'framer-motion';
import { useState, useEffect } from 'react';
// @mui

import Box from '@mui/material/Box';
import {
  Button,
  FormControl,
  Typography,
  MenuItem,
  Grid,
  Modal,
  // Divider,
  Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField,
  IconButton,
 
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { FaRegUser } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import * as Yup from 'yup';
import { MdLockReset } from "react-icons/md";
import axios, { endpoints } from 'src/utils/axios';
import Avatar from '@mui/material/Avatar';
import LoadingButton from '@mui/lab/LoadingButton';
// routes
import { useSnackbar } from 'notistack';
import InputAdornment from '@mui/material/InputAdornment';
import { useRouter } from 'src/routes/hook';
import { useBoolean } from 'src/hooks/use-boolean';
import Iconify from 'src/components/iconify';
import { paths } from 'src/routes/paths';
import { useMockedUser } from 'src/hooks/use-mocked-user';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
// theme
import { paper } from 'src/theme/css';

//
import { RHFTextField } from 'src/components/hook-form';
import Scrollbar from '../../scrollbar';
//
import { useSettingsContext } from '../context';
import BaseOptions from './base-option';
import LayoutOptions from './layout-options';
import PresetsOptions from './presets-options';
import StretchOptions from './stretch-options';
import FullScreenOption from './fullscreen-option';

// ----------------------------------------------------------------------

export default function SettingsDrawer() {
  const theme = useTheme();
 const auth = useAuthContext();
  const ids =auth.user?.id
  const role = auth.user?.roleType;
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
      const passwordVisibility = useBoolean();
      const confirmPasswordVisibility = useBoolean();
     // Validation Schema for Reset Password
      const ResetPasswordSchema = Yup.object().shape({
        newPassword: Yup.string()
          .required('New password is required')
          .min(6, 'Password must be at least 6 characters')
          .max(20, 'Password must be at most 20 characters'),
        confirmPassword: Yup.string()
          .oneOf([Yup.ref('newPassword')], 'Passwords must match')
          .required('Please confirm your password'),
      });
      const methods = useForm({
        resolver: yupResolver(ResetPasswordSchema),
      });

      const {
        handleSubmit,
        clearErrors,
        reset,
        formState: { isSubmitting },
      } = methods;
  
  const [detail, setDetail] = useState({
    name: '',
    username:'',
    email: '',
    countryCode:'+91',
    mobile: '',
    password: '',
    status: 'Active', 
    roleType: null,    
  });


    const onSubmit = handleSubmit(async (data) => {
      if (data) {
        if (data.confirmPassword === data.newPassword) {
         const formdata={
          "newPassword":data.newPassword
         }
  
          try {
            const response = await axios.post(`${endpoints.auth.resetPassword}`,formdata);
         
            if (response) {
              setOpen(true);
              enqueueSnackbar(response.data.message, { variant: 'success' });
            }
          } catch (error) {
           
            enqueueSnackbar(error.message, { variant: 'error' });
          } 
        }
      }
      else{
        enqueueSnackbar("Token is required", { variant: 'error' });
      }
    
    });

  const settings = useSettingsContext();
 const navigate =useNavigate();
 const [openProfile,setOpenProfile] =useState(false)
 const [openViewDialog,setOpenViewDialog] =useState(false)
   const redirectToProfile = (row) => {
      navigate(paths.dashboard.user.profile);
    };
  // Close the dialog
 const handleCloseViewDialog = () => {
  setOpenViewDialog(false)
      clearErrors();
 };
 
 const handleCloseProfileDialog = () => {
  setOpenProfile(false)
      clearErrors();
 };

 const handleOpenProfileDialog = () => {
  setOpenProfile(true)

  axios.get(`${endpoints.user.getuser}${ids}`)
  .then((response) => {
    
    let roleName = '';
    if (response.data.user.roleType === 1) {
      roleName = "Super Admin";
    } else if (response.data.user.roleType === 2) {
      roleName = "Counsellor";
    } else if (response.data.user.roleType === 3) {
      roleName = "Admin";
    } else if (response.data.user.roleType === 4) {
      roleName = "Trainer";
    } 
         setDetail({
           id: response.data.user.id,
           name: response.data.user.username,
           username:response.data.user.name,
           countryCode:response.data.user.countryCode,
           roleType:roleName,
           mobile: response.data.user.mobile,
           email: response.data.user.email,
           status: response.data.user.status,
           createdAt: response.data.user.createdAt,
          //  createdAt: response.data.user.createdAt,
           createdBy: response.data.user.createdBy,
           updatedAt: response.data.user.updatedAt,
           updatedBy: response.data.user.updatedBy,
         });
  })
  .catch((error) => {
// console.log("Error",error.message);
  });
      clearErrors();
 };

 
 const { user } = useMockedUser();

 const { logout } = useAuthContext();

 const popover = usePopover();
 const router = useRouter();

 const handleLogout = async () => {
   try {
     await logout();
     popover.onClose();
     router.replace('/');
   } catch (error) {
     console.error(error);
   }
 };
const handleopen =async () => {
 try {
   setOpenViewDialog(true)
 } catch (error) {
   setOpenViewDialog(false)
   console.error(error);
 }
};

  const labelStyles = {
    mb: 1.5,
    color: 'text.disabled',
    fontWeight: 'fontWeightSemiBold',
  };

  const renderHead = (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ py: 2, pr: 1, pl: 2.5 }}
    >
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Settings
      </Typography>

      <Tooltip title="Reset">
        <IconButton onClick={settings.onReset}>
          <Badge color="error" variant="dot" invisible={!settings.canReset}>
            <Iconify icon="solar:restart-bold" />
          </Badge>
        </IconButton>
      </Tooltip>

      <IconButton onClick={settings.onClose}>
        <Iconify icon="mingcute:close-line" />
      </IconButton>
    </Stack>
  );

  const renderMode = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Mode
      </Typography>
      <BaseOptions
  value={settings.themeMode}
  onChange={(newValue) => {
    localStorage.setItem("themeMode", newValue); // Store mode in localStorage
    settings.onUpdate("themeMode", newValue); // Update the state/context
  }}
  options={["light", "dark"]}
  icons={["sun", "moon"]}
/>

{/* 
      <BaseOptions
        value={settings.themeMode}
        onChange={(newValue) => settings.onUpdate('themeMode', newValue)}
        options={['light', 'dark']}
        icons={['sun', 'moon']}
      /> */}
    </div>
  );

  const renderContrast = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Contrast
      </Typography>

      <BaseOptions
        value={settings.themeContrast}
        onChange={(newValue) => settings.onUpdate('themeContrast', newValue)}
        options={['default', 'bold']}
        icons={['contrast', 'contrast_bold']}
      />
    </div>
  );

  const renderDirection = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Direction
      </Typography>

      <BaseOptions
        value={settings.themeDirection}
        onChange={(newValue) => settings.onUpdate('themeDirection', newValue)}
        options={['ltr', 'rtl']}
        icons={['align_left', 'align_right']}
      />
    </div>
  );

  const renderLayout = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Layout
      </Typography>

      <LayoutOptions
        value={settings.themeLayout}
        onChange={(newValue) => settings.onUpdate('themeLayout', newValue)}
        options={['vertical','mini'
        // ,'horizontal'
        ]}
      />
    </div>
  );

  const renderStretch = (
    <div>
      <Typography
        variant="caption"
        component="div"
        sx={{
          ...labelStyles,
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        Stretch
        <Tooltip title="Only available at large resolutions > 1600px (xl)">
          <Iconify icon="eva:info-outline" width={16} sx={{ ml: 0.5 }} />
        </Tooltip>
      </Typography>

      <StretchOptions
        value={settings.themeStretch}
        onChange={() => settings.onUpdate('themeStretch', !settings.themeStretch)}
      />
    </div>
  );

  const renderForm = (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Typography variant="body1">
          New Password <span style={{ color: 'red' }}>*</span>
        </Typography>
        {/* <RHFTextField
          name="newPassword"
          label="Enter your new password"
      
          type={passwordVisibility.value ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={passwordVisibility.onToggle} edge="end">
                  <Iconify
                    icon={passwordVisibility.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        /> */}

        <Typography variant="body1">
          Confirm Password <span style={{ color: 'red' }}>*</span>
        </Typography>
        <RHFTextField
          name ="confirmPassword"
          label="Confirm your new password"
         
          type={confirmPasswordVisibility.value ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={confirmPasswordVisibility.onToggle} edge="end">
                  <Iconify
                    icon={
                      confirmPasswordVisibility.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'
                    }
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Grid container>
          <Grid item xs={9}>
          <LoadingButton
 
          color="primary"
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          Reset Password
        </LoadingButton>
          </Grid>
<Grid item xs={3}>

<Button
    variant="contained"
    onClick={handleCloseViewDialog}
    sx={{
      padding: '11px 22px', 
      backgroundColor: '#eaeaea', 
      border: '1px solid #eaeaea',
      color: '#404040', 
      '&:hover': {
        backgroundColor: '#d6d6d6',
        borderColor: '#d6d6d6',
      },
    }}
  >
    Close
  </Button>
</Grid>
        </Grid>

      </Stack>
    </FormProvider>
  );

  const renderPresets = (
    <div>
      <Typography sx={{...labelStyles}}>
        Colors
      </Typography>

      <PresetsOptions
        value={settings.themeColorPresets}
        onChange={(newValue) => settings.onUpdate('themeColorPresets', newValue)}
      />
    </div>
  );

 if(auth.user){
  return (
    <Drawer
      anchor="right"
      open={settings.open}
      onClose={settings.onClose}
      slotProps={{
        backdrop: { invisible: true },
      }}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          ...paper({ theme, bgcolor: theme.palette.background.default }),
          width: 280,
        },
      }}
    >
      {renderHead}

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Scrollbar>
        <Stack spacing={3} sx={{ p: 3 }}>
          {renderMode} 

          {/* {renderContrast} */}

          {renderDirection}
    
        {/* <MenuItem
          onClick={handleopen}
          sx={{ml:1,mt:-2, fontWeight: '500', color: 'success.main'}}
        >
        <Box sx={{ fontSize: '25px' }}>
  <MdLockReset />
</Box>

         <Typography  sx={{...labelStyles,ml:3}}> Reset Password</Typography>
         
        </MenuItem> */}

          {/* {renderStretch} */}

          {/* {renderPresets} */}
          {renderLayout}
          <MenuItem
          onClick={handleOpenProfileDialog}
          sx={{ml:1,mt:-1, fontWeight: '500', color:'info.main'}}
        >
                <Box sx={{ fontSize: '20px' }}>
  <FaRegUser />
</Box>
         <Typography  sx={{...labelStyles,ml:3,mt:1}}>Profile</Typography>
         
         
        </MenuItem>
        <MenuItem
          onClick={handleLogout}
          sx={{ mt:-2,ml:1, fontWeight: '500', color: 'error.main',fontSize:'12px' }}
        >
        <Box sx={{ fontSize: '20px' }}>
  <FiLogOut />
</Box>
  <Typography  sx={{...labelStyles,ml:3}}> Logout</Typography>
        </MenuItem>
      
        </Stack>
      </Scrollbar>

      <FullScreenOption />
      
      <Modal
           sx={() => ({
           pt: 1,
           display: 'flex',
           alignItems:'center',
           flexDirection: 'row',
           width: {
             xs: '100%', 
             sm: '80%',  
             lg: '40%',  
           },
           margin: '0 auto',
          })}
          open={openProfile}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
 
  borderRadius: '10px',
  boxShadow: 24,
  p:3,

          }}>
            <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ml:3,mt:2 }}>
             Profile Details
            </Typography>
        


<TableContainer sx={{ mt: 2,border:'1px solid #DBD9FC',borderRadius:'5px'}}>
  <Table>
    <TableBody>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{  fontWeight: 'bold', backgroundColor: '#f3f2ff'  }}>Name :</TableCell>
        <TableCell>{detail.name}</TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff'  }}>Email :</TableCell>
        <TableCell>{detail.email}</TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff' }}>Mobile :</TableCell>
        <TableCell>{detail.countryCode} {detail.mobile}</TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff' }}>Role :                              </TableCell>
        <TableCell>
        <Button
              style={{
                fontSize: 12,
                fontWeight: 500,
                color: '#7068ff',
                padding: '6px 10px',
                backgroundColor: '#e2e1ff',
                borderRadius: '5px',
              }}
            >
            
              {detail.roleType}
            </Button>
        </TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell  sx={{ fontWeight: 'bold', backgroundColor: '#f3f2ff' }}>Status :</TableCell>
        <TableCell>
      
        <Button
              style={{
                fontSize: 12,
                fontWeight: 500,
                color: detail.status === 'Active' ? '#28c76f' : '#ff2c2c',
                padding: '6px 10px',
                backgroundColor: detail.status === 'Active' ? '#ddf6e8' : '#ffbfbf',
                borderRadius: '5px',
              }}
            >
              {detail.status}
            </Button>
        </TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: '0.2px solid #DBD9FC' }}>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: '#f3f2ff' }}>Created On:</TableCell>
        <TableCell>{detail.createdAt}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor:'#f3f2ff' }}>Updated On:</TableCell>
        <TableCell>{detail.updatedAt}</TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>

<Box sx={{
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 3,
}}>
  <Button
    variant="contained"
    onClick={handleCloseProfileDialog}
    sx={{
      padding: '8px 16px', 
      backgroundColor: '#eaeaea', 
      border: '1px solid #eaeaea',
      color: '#404040', 
      '&:hover': {
        backgroundColor: '#d6d6d6',
        borderColor: '#d6d6d6',
      },
    }}
  >
    Close
  </Button>
</Box>
          </Box>
        </Modal>
        <Modal
           sx={() => ({
           pt: 1,
           display: 'flex',
           alignItems:'center',
           flexDirection: 'row',
           width: {
             xs: '100%', 
             sm: '55%',  
             lg: '55%',  
           },
           margin: '0 auto',
          })}
          open={openViewDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          
               <Box sx={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: 5,
      borderRadius: 2,
      boxShadow: 3,
      // zIndex: 9999,
      width: {
        sm:'420px',
        xs:"330px"
      },
     
    }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box component="img" src="/logo/finxllogo.png" sx={{ width: 150, height: 50 }} />
      </Box>

      <Stack spacing={1} sx={{ mb: 1 }}>
        <Typography variant="h4" sx={{mt:2}}>Reset Password</Typography>
        <Typography variant="subtitle1" sx={{ color: 'grey',mb:1 }}>
          Enter and confirm your new password to reset your account password.
        </Typography>
      </Stack>

      {renderForm}

      <Stack spacing={1} sx={{ mt: 3 }}>
        <Typography variant="subtitle2" sx={{ color: 'grey', textAlign: 'center' }}>
          Copyright © 2024 Finxl. Crafted by Deepminds Infotech Pvt. Ltd.
        </Typography>
      </Stack>
    </Box>
{/* <Box sx={{
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 3,
}}>
  <Button
    variant="contained"
    onClick={handleCloseViewDialog}
    sx={{
      padding: '8px 16px', 
      mb:2,
      backgroundColor: '#eaeaea', 
      border: '1px solid #eaeaea',
      color: '#404040', 
      '&:hover': {
        backgroundColor: '#d6d6d6',
        borderColor: '#d6d6d6',
      },
    }}
  >
    Close
  </Button>
</Box> */}
       
        </Modal>
    </Drawer>
  );

 }
 return null;
}
